module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUdwTG9vb3BwcGtra29vb25ubm5ubnBwcHBwcLe3t8RqtBgAAAAJdFJOUwD6jxzXPEqra3wz+mwAAABSSURBVBjTY5iJChgmMCADTnrxmYtR+SbCKHxmxwAUvokoin6YNIwPk4by4dJQPoc4mv2KCqh8JiE098EUwPgwBXD3QhXA+UxiaP5NoFN4osUnAGmqJzicl3PqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/casePage/turn-page-left.png
// module id = GoZN
// module chunks = 0